<template>
  <b-modal
    id="price-offer-modal"
    size="lg"
    ref="modal"
    title="Oferta cenowa"
    @hidden="onClose"
    @show="onShow"
    :hide-footer="true"
  >
    <ValidationObserver
      ref="offerFormValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="constructionOffer"
    >
      <b-form-group :label="`Oferta w ${getMainBaseCurrency}:`" label-for="offer_price">
        <ValidationProvider
          name="offer_price"
          rules="required|min:0"
          v-slot="validationContext"
        >
          <b-input-group>
            <b-form-input
              id="offer_price"
              v-model="offer"
              type="number"
              step="0.01"
              :number="true"
              min="0"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                class="btn btn-primary btn-sm"
                variant="primary"
                type="submit"
                form="constructionOffer"
              >Zapisz</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-invalid-feedback
            :state="getValidationState(validationContext)"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>
    </ValidationObserver>

    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <p class="mb-3">Lista dodatkowych ofert:</p>
      <button class="btn btn-outline-primary mb-3 btn-sm" @click="showAddSingleOffferModal">
        <i class="fas fa-plus"></i> Dodaj ofertę
      </button>
    </div>

    <table
      ref="oferts_table"
      class="table b-table table table-list table-pro table-offers b-table-stacked-lg mt-0 mb-0">
      <thead>
        <tr>
          <th>Nr.</th>
          <th>Ważne do</th>
          <th class="text-right">Kwota netto</th>
          <th class="text-center">Opcje</th>
        </tr>
      </thead>
      <tbody>

        <template v-if="isBusy">
          <tr>
            <td colspan="8" class="text-center">
              <TableSpiner />
            </td>
          </tr>
        </template>

        <template v-if="offers.length === 0 && isBusy === false">
          <tr>
            <td colspan="8" class="text-center">
              <div class="empty">
                <i class="fas fa-clipboard-list empty-state"></i>
                <span class="empty-search">Brak ofert</span>
              </div>
            </td>
          </tr>
        </template>

        <template v-else-if="offers.length > 0 && isBusy === false" v-for="(item, index) in offers">
          <tr :key="index" :class="{ 'offer-item-hasDescription': item.description }">
            <td data-label="Nr">{{item.name}}</td>
            <td data-label="Ważne do">{{ item.end_date | date }}</td>
            <td data-label="Kwota netto" class="text-right">{{item.netto_amount.toFixed(2)}}</td>
            <td data-label="Opis" v-if="screenWidth < 992 && item.description !== null">{{item.description}}</td>
            <td data-label="Opcje" v-else class="text-center d-flex justify-content-center">
                <button
                style="padding: 0.2rem 0.66rem;"
                  class="btn btn-sm btn-rounded btn-light mr-2"
                  @click="downloadOffer(item.id, $event)"
                >
                  <i class="fas fa-download"></i>
                </button>
              <b-dropdown no-caret right variant="light" class="btn-rounded">
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button
                  @click="showEditOfferModal(item.id)"
                  >Edytuj</b-dropdown-item-button
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button
                  @click="confirmRemove(item)"
                  class="danger"
                >
                  <i class="fas fa-trash-alt"></i> Usuń
                </b-dropdown-item-button>
              </b-dropdown>
            </td>
          </tr>
          <tr class="offer-item-description" :key="'description_'+index" v-if="screenWidth > 992 && item.description !== null">
              <td data-label="Opis" colspan="4">
                <small>{{item.description}}</small>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <ConstructionModalAddSingleOffer
    ref="offerModal"
    :countOffers="offers.length"
    @submit="submitOffer"
    />
  </b-modal>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import TableSpiner from "@/components/TableSpiner";
import ConstructionModalAddSingleOffer from "@/components/construction/ConstructionModalAddSingleOffer";
import { Offers } from "@/services/offers.service";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "ConstructionModalOffer",
  components: { TableSpiner, ConstructionModalAddSingleOffer },
  props: {
    construction_id: { type: Number },
    offer_price: {
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {
      isBusy: false,
      offer: 0,
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
    computed: {
    ...mapGetters("construction", ["info"]),
    ...mapGetters("company", [ "getMainBaseCurrency"]),
    ...mapGetters("offers", [ "offers"]),
    // calculatedOfferPrice() {
      // var offerListPrice = 0;
      // if (this.offers.length > 0) {
      //   this.offers.forEach(element => {
      //     console.log('if');
      //     console.log(element);
      //     offerListPrice += element.price;
      //   });
      //   this.offer = offerListPrice;
      //   return offerListPrice.toFixed(2);
      // } else{
        // return this.offer
      // }
    // },
    screenWidth(){
      let width = screen.width;
      return width;
    },
  },
  methods: {
    ...mapActions("construction", ["offerprice"]),
    ...mapActions("offers", ["getOffers", "offerRemove"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    showAddSingleOffferModal() {
      this.$bvModal.show("addSingleOffer-modal");
    },
    showEditOfferModal(offerId) {
      Offers.getOffert({
          constructionId: this.info.id,
          offerId,
      }).then((data) => {
        this.$refs.offerModal.show(data);
      });
    },
    downloadOffer(offerId, event){
      this.$Progress.start();
      let btn = event.target.closest('button');
      btn.disabled = true;
      Offers.download({
          constructionId: this.info.id,
          offerId,
      }).then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
          window.open(url);
      }).finally(() => {
          btn.disabled = false;
      });
    },
    submitOffer() {
      // console.log(data);
    },
    confirmRemove(item) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć ofertę ",
              h("strong", item.name),
              " z budowy ",
              h("strong", this.info.name),
              " ?"
            ])
          ],
          {
            title: "Potwierdź usunięcie oferty",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE"
          }
        )
        .then(result => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.offerRemove({
          constructionId: this.info.id,
          offerId: item.id,
          })
        });
    },
    onShow() {
      this.isBusy = true;
      this.getOffers(this.info.id)
      .then(() => {
        this.offer = parseFloat(this.offer_price)
        this.isBusy = false;
      });
    },
    onClose() {
      this.offer = 0;
    },
    onSubmit() {
      this.$refs.offerFormValidation.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        this.offerprice({
          construction_id: this.construction_id,
          offerPrice: this.offer,
        })
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide("price-offer-modal");
            });
          })
          .catch((error) => {
            this.$refs.offerFormValidation.setErrors(
              error.response.data.fields
            );
          });
      });
    },

  },
};
</script>

<style>
.offer-item-hasDescription{
  border-bottom: 0!important;
}
.offer-item-hasDescription td{
  padding-bottom: 5px!important;
}
.offer-item-description td{
  padding-top: 0!important;
  line-height: 1.2;
}

.table-offers tr:hover{
  background-color: initial!important;
}

@media(max-width: 991.98px){
  .table-offers tbody > tr > [data-label]::before{
    width: 100%!important;
    text-align: left!important;
  }
  .table-offers tbody > tr > [data-label="Opcje"]{
    flex-wrap: wrap;
  }
  .table-offers tbody > tr > .text-right{
    text-align: left!important;
  }
  .table-offers tbody .b-dropdown{
    width: fit-content!important;
    width: -moz-fit-content!important;
  }
}

</style>
